import React from 'react';
import { MenuItemLink } from 'react-admin';
import ListIcon from '@material-ui/icons/List'
import EmailIcon from '@material-ui/icons/Email'
import WarningIcon from '@material-ui/icons/Warning'
import FilterListIcon from '@material-ui/icons/FilterList'
import ConnectionsIcon from '@material-ui/icons/SettingsInputComponent'
import AlarmIcon from '@material-ui/icons/Alarm'
import DescriptionIcon from '@material-ui/icons/Description'
import PauseIcon from '@material-ui/icons/Pause';

export const CustomMenu = props => {
    let url = "new.integrations.entrecloud.se";
    if (window.location.hostname.includes("staging") || window.location.hostname.includes("testing") || window.location.hostname == 'localhost') {
        url = "new.integrations.staging.entrecloud.se";
    }

    return (
        <div>
            <MenuItemLink dense
                to="/runs"
                primaryText="Runs"
                leftIcon={<ListIcon color="primary" />}
            />
            <MenuItemLink dense
                to="/objects"
                primaryText="Objects"
                leftIcon={<DescriptionIcon color="primary" />}
            />
            <MenuItemLink dense
                to="/integrationinstances"
                primaryText="Connections"
                leftIcon={<ConnectionsIcon color="primary" />}
            />
            <MenuItemLink dense
                to="/errorfilters"
                primaryText="Error filters"
                leftIcon={<FilterListIcon color="primary" />}
            />
            <MenuItemLink dense
                to="/errorreport"
                primaryText="Error report"
                leftIcon={<FilterListIcon color="primary" />}
            />
            <MenuItemLink dense
                to="/alarms"
                primaryText="Alarms"
                leftIcon={<AlarmIcon color="primary" />}
            />
            <MenuItemLink dense
                to="/alarmtemplates"
                primaryText="Alarm Templates"
                leftIcon={<AlarmIcon color="primary" />}
            />
            <MenuItemLink dense
                to="/alarmrecipientlists"
                primaryText="Recipient lists"
                leftIcon={<EmailIcon color="primary" />}
            />
            <MenuItemLink dense
                component="a"
                href={'https://' + url + '/#/errors'}
                primaryText="Errors"
                leftIcon={<WarningIcon color="primary" />}
            />
            <MenuItemLink dense
                component="a"
                href={'https://' + url + '/#/pause'}
                primaryText="Pause"
                leftIcon={<PauseIcon color="primary" />}
            >
            </MenuItemLink>
        </div>
    );
};
